import WebGlApp from './js/app/app';

export default WebGlApp;
